import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";
import BrandMark from "@/components/BrandMark";
import { trackSignup } from "@/lib/analytics";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ full_name: "", company_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      trackSignup();
      toast.success("Compañía inicializada. Bienvenido al command center.");
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo registrar");
    } finally {
      setLoading(false);
    }
  };

  const F = (k) => ({
    value: form[k],
    onChange: (e) => setForm({ ...form, [k]: e.target.value }),
    className: "rounded-none bg-[var(--surface)] border-[var(--border)] h-11 font-mono",
    required: true,
  });

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--bg)]" data-testid="register-page">
      <div className="w-full max-w-lg border border-[var(--border)] bg-[var(--surface)] p-8 relative">
        <div className="absolute -top-3 left-6 bg-[var(--surface)] px-3 label-mono">Nuevo Tenant</div>

        <div className="flex items-center gap-3 mb-8">
          <BrandMark className="w-10 h-10" />
          <div>
            <div className="font-display font-black text-lg tracking-tight leading-none">AGENT COMPANY OS</div>
            <div className="label-mono mt-1">Registro seguro</div>
          </div>
        </div>

        <h2 className="font-display font-bold text-3xl tracking-tight mb-1">Crea tu compañía</h2>
        <p className="text-sm text-[var(--text-dim)] mb-6">
          Cada compañía es un tenant aislado. Los 8 agentes master se activan al instante.
        </p>

        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="label-mono">Nombre</Label>
              <Input {...F("full_name")} placeholder="Ada Lovelace" data-testid="reg-name" />
            </div>
            <div>
              <Label className="label-mono">Empresa</Label>
              <Input {...F("company_name")} placeholder="Acme AI" data-testid="reg-company" />
            </div>
          </div>
          <div>
            <Label className="label-mono">Email</Label>
            <Input type="email" {...F("email")} placeholder="ada@acme.com" data-testid="reg-email" />
          </div>
          <div>
            <Label className="label-mono">Contraseña</Label>
            <Input type="password" {...F("password")} placeholder="Mínimo 8 caracteres" data-testid="reg-password" />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full rounded-none h-11 bg-[var(--accent)] text-[var(--bg)] hover:bg-[var(--accent)]/80 font-semibold"
            data-testid="reg-submit"
          >
            <UserPlus className="w-4 h-4 mr-2" />
            {loading ? "Creando..." : "Inicializar Compañía"}
          </Button>
        </form>

        <div className="mt-5 text-center text-sm text-[var(--text-dim)]">
          ¿Ya tienes cuenta?{" "}
          <Link to="/login" className="text-[var(--accent)] hover:underline" data-testid="link-login">
            Inicia sesión
          </Link>
        </div>
      </div>
    </div>
  );
}
